import { jsPDF } from "jspdf";
import { MPlus_Encoded_Base64 } from "./mplus-encoded-base64.js";
import QRCode from "qrcode";

/**
 * @param busInfoList バスの情報リスト
 */
export async function createBusQrCodePdf(busInfoList) {
  // ----- PDF作成処理 ----- //
  // Default export is a4 paper, portrait, using millimeters for units
  const doc = new jsPDF("a4");

  // pdfのタイトル（タブに表示されるやつ）
  doc.setProperties({
    title: "バス情報一覧"
  });

  // フォントデータの適応
  doc.addFileToVFS("mplus.ttf", MPlus_Encoded_Base64);
  doc.addFont("mplus.ttf", "mplus", "normal");
  doc.setFont("mplus", "normal");

  // フォントサイズの設定
  doc.setFontSize(12);

  // 固定値の定義（Wordを元に数値を入力）
  const WIDTH = 210;
  const HEIGHT = 297;
  const TOP_MARGIN = 10;
  const LEFT_MARGIN = 10;
  const QR_IMAGE_SIZE = 90;
  const QR_IMAGE_MARGIN = 10;
  const ONE_LINE_HEIGHT = 8;
  const SIDE_MARGIN = 30;
  const ONE_LINE_CHARACTERS = 35;
  const ONE_CHARACTER_WIDTH = (WIDTH - SIDE_MARGIN * 2) / ONE_LINE_CHARACTERS; // 全角文字 1文字当たりの幅

  // ページ番号
  var creatingPageNo = 1;

  /* 以下、1ページ分 */
  for (let busInfo of busInfoList) {
    // 1ページ目でなければ新しいページを作成
    if (creatingPageNo != 1) {
      doc.addPage("a4");
    }

    /* タイトル */
    /* eslint-disable */
    doc.text("配布用", LEFT_MARGIN, TOP_MARGIN);
    /* eslint-enable */

    /* QR */
    var qrStr = JSON.stringify({
      S: "Bus",
      Q: [busInfo.vehicle_id]
    });
    var qrURL = await QRCode.toDataURL(qrStr);

    doc.addImage(
      qrURL,
      "JPEG",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      TOP_MARGIN + QR_IMAGE_MARGIN,
      QR_IMAGE_SIZE,
      QR_IMAGE_SIZE
    );

    // バスQRコード
    doc.text(
      "バスQRコード",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      TOP_MARGIN + QR_IMAGE_MARGIN * 1 + QR_IMAGE_SIZE
    );

    // 車番
    doc.text(
      "車番：",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      TOP_MARGIN + QR_IMAGE_MARGIN * 1 + QR_IMAGE_SIZE + ONE_LINE_HEIGHT
    );

    var vehicleNumber = doc.splitTextToSize(
      busInfo.vehicle_number,
      WIDTH / 2 - QR_IMAGE_SIZE / 3 - ONE_CHARACTER_WIDTH
    );
    doc.text(
      vehicleNumber,
      WIDTH / 2 - QR_IMAGE_SIZE / 2 + ONE_CHARACTER_WIDTH * 3,
      TOP_MARGIN + QR_IMAGE_MARGIN + QR_IMAGE_SIZE + ONE_LINE_HEIGHT
    );

    // バス会社名
    doc.text(
      "バス会社名：",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      TOP_MARGIN +
        QR_IMAGE_MARGIN * 1 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT * 2 +
        vehicleNumber.length
    );

    var operatorName = doc.splitTextToSize(
      busInfo.vehicle_operator_name,
      WIDTH / 2 - QR_IMAGE_SIZE / 3 - ONE_CHARACTER_WIDTH * 4.5
    );
    doc.text(
      operatorName,
      WIDTH / 2 - QR_IMAGE_SIZE / 2 + ONE_CHARACTER_WIDTH * 6,
      TOP_MARGIN +
        QR_IMAGE_MARGIN * 1 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT * 2 +
        vehicleNumber.length
    );

    // 2ページで使うラインのHeight
    const PAGE_LINE_HEIGHT = (vehicleNumber.length + operatorName.length) * 2;

    // 中央の点線
    doc.setLineDash([1, 1.5, 2, 1.5]);
    doc.line(0, HEIGHT / 2, WIDTH, HEIGHT / 2);

    // ココから下部

    /* タイトル */
    /* eslint-disable */
    doc.text(
      "保存用",
      LEFT_MARGIN,
      HEIGHT / 2 + TOP_MARGIN
    );
    /* eslint-enable */

    doc.addImage(
      qrURL,
      "JPEG",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      HEIGHT / 2 + TOP_MARGIN + QR_IMAGE_MARGIN,
      QR_IMAGE_SIZE,
      QR_IMAGE_SIZE
    );

    doc.text(
      "バスQRコード",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      HEIGHT / 2 +
        TOP_MARGIN +
        QR_IMAGE_MARGIN * 2 +
        QR_IMAGE_SIZE -
        PAGE_LINE_HEIGHT
    );

    // 車番
    doc.text(
      "車番：",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      HEIGHT / 2 +
        TOP_MARGIN +
        QR_IMAGE_MARGIN * 2 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT -
        PAGE_LINE_HEIGHT
    );

    var vehicleNumberSave = doc.splitTextToSize(
      busInfo.vehicle_number,
      WIDTH / 2 - QR_IMAGE_SIZE / 3 - ONE_CHARACTER_WIDTH
    );
    doc.text(
      vehicleNumberSave,
      WIDTH / 2 - QR_IMAGE_SIZE / 2 + ONE_CHARACTER_WIDTH * 3,
      HEIGHT / 2 +
        TOP_MARGIN +
        QR_IMAGE_MARGIN * 2 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT -
        PAGE_LINE_HEIGHT
    );

    // バス会社名
    doc.text(
      "バス会社名：",
      WIDTH / 2 - QR_IMAGE_SIZE / 2,
      HEIGHT / 2 +
        TOP_MARGIN +
        QR_IMAGE_MARGIN * 2 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT * 2 +
        vehicleNumberSave.length -
        PAGE_LINE_HEIGHT
    );

    var operatorNameSave = doc.splitTextToSize(
      busInfo.vehicle_operator_name,
      WIDTH / 2 - QR_IMAGE_SIZE / 3 - ONE_CHARACTER_WIDTH * 4.5
    );
    doc.text(
      operatorNameSave,
      WIDTH / 2 - QR_IMAGE_SIZE / 2 + ONE_CHARACTER_WIDTH * 6,
      HEIGHT / 2 +
        TOP_MARGIN +
        QR_IMAGE_MARGIN * 2 +
        QR_IMAGE_SIZE +
        ONE_LINE_HEIGHT * 2 +
        vehicleNumberSave.length -
        PAGE_LINE_HEIGHT
    );

    creatingPageNo++;
  }

  window.open(doc.output("bloburl"));
}
